import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AppConfigService } from 'src/app/core/services/config.service';
import {
  EditableMenuHelpsDto,
  MenuHelp,
  UpdateMenuCommand,
  UpdateMenuHelpsCommands,
} from '../../../../core/api/models';
import { MenusService } from '../../../../core/api/services/menus.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { FileCardListComponent } from "../../../../shared/components/file-card-wrapper/file-card-list-component/file-card-list.component";
import { AppNgxEditorComponent } from "../../../../shared/components/text-editor/app-ngx-editor/app-ngx-editor.component";


@Component({
    selector: 'app-menu-helps-form',
    templateUrl: './menu-helps-form.component.html',
    styleUrls: [],
    imports: [BaseFormModule, FileCardListComponent, AppNgxEditorComponent]
})
export class MenuHelpsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  url: string = AppConfigService.config.apiUrl;
  formPageConfig: FormPageConfig<UpdateMenuCommand> = {};
  @Input('menuHelpsData') model: EditableMenuHelpsDto = {};
  @Input() menuId: number;
  files: MenuHelp[] = [];
  currentService = inject(MenusService);
  apiMethodName: string = this.currentService.menusUploadHelpFiles.name;

  //#endregion

  ngOnInit(): void {
    this.model.id = this.menuId;
    super.ngOnInit();
    this.initForm();
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl(this.model.menuHelpTitle, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      textHelp: new FormControl(this.model.textHelp, [Validators.required]),
    });
    if (this.model.menuHelps?.length) this.files = this.model.menuHelps;
  }

  //#region Api

  baseUpdateApi(model: UpdateMenuHelpsCommands) {
    const body: UpdateMenuHelpsCommands = {
      id: this.menuId,
      menuHelpTitle: this.form.get('title')?.value,
      textHelp: this.form.get('textHelp')?.value,
      menuHelps: this.files,
    };
    if (this.loading) return;
    this.loading = true;
    this.unSubs();
    this.currentService
      .menusUpdateMenuHelpsPut({ body })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (!this.form.valid) return;
    this.baseUpdateApi(this.model);
  }

  deleteCard(file: any): void {
    const index = this.files.indexOf(file);
    if (index > -1 && index < this.files.length) {
      this.files.splice(index, 1);
    }
  }

  addNewCard(): void {
    const newFile = { title: '' };
    this.files.push(newFile);
  }
  
}
